import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import { FormGroup, AbstractControl, Validators, FormBuilder, FormGroupDirective, ValidatorFn, ValidationErrors } from '@angular/forms';
import { takeUntil, take, filter, switchMap, map, tap } from 'rxjs/operators';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import { UniqueIdGenerator } from '@utilities/UniqueIdGenerator';
import { isNullOrUndefined } from 'util';
import { ControlFormsService } from '@services/control-forms.service';


interface StudentModel {
  id: string;
  Name: string;
  Grade: string;
  Age: string;
  Place: string;
} 

@Component({
  selector: 'control-student',
  templateUrl: './control-student.component.html',
  styleUrls: ['./control-student.component.scss']
})
export class ControlStudentComponent implements OnInit, OnDestroy {
  @Input() sfcontrol: SpecialFormControl;
  @Output('blurAction') _blurAction: EventEmitter<any> = new EventEmitter();
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();

  public _students$ = new BehaviorSubject<StudentModel[]>([]);
  public _students: StudentModel[] = [];
  public dataSource = new MatTableDataSource([]);
  public titulo: string;
  public formStatus = false;
  public formularioDatos: FormGroup;
  public erroresFormulario = {
    Name: '',
    Grade: '',
    Age: '',
    Place: '',
  };
  public displayedColumns = ['Name', 'Age', 'Grade', 'Place', 'delete'];
  public grades = ['Preescolar','Prekinder', 'Kinder', 'Transición', 'Primero', 'Segundo', 'Tercero', 'Cuarto','Quinto','Sexto','Séptimo','Octavo','Noveno','Décimo','Undécimo','Doudécimo','Universidad'];
  
  private _addElement = new Subject<StudentModel>();
  private _deleteElement = new Subject<string>();
  private _finisher = new Subject<void>();

  private mensajesValidacion = {
    Name: {
      required: 'Especifique el nombre',
      pattern:'El dato ingresado no tiene el formato esperado',
    },
    Grade: {
      required: 'Especifique el grado',
    },
    Age: {
      required: 'Espeficique la edad',
    },
    Place: {
      required: 'Espeficique el lugar donde estudia',
    }
  };

  constructor( 
    private fb: FormBuilder,
    private _controlFormsService: ControlFormsService,
     ) {
    this.construyeFormulario();
  }

  private construyeFormulario(): void {
    this.formularioDatos = this.fb.group({
      Name: [ '', [Validators.required,Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(?: [a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$')]],
      Grade: [ '', Validators.required],
      Age: [ '', Validators.required],
      Place: [ '', Validators.required],
    }, );

    this.formularioDatos.valueChanges
    .pipe( takeUntil( this._finisher ) )
    .subscribe(data =>{
      this.alCambiarValor(data)
    });

  }

  private alCambiarValor(data?: any): void {
    if (!this.formularioDatos) {
      alert('No existe formularioDatos');
      return;
    }

    const formulario: FormGroup = this.formularioDatos;

    for (const campo in this.erroresFormulario) {
      if (campo in this.erroresFormulario) {
        const control: AbstractControl = formulario.get(campo);
        this.erroresFormulario[campo] = '';
        if (control && control.dirty && !control.valid) {
          const mensajes = this.mensajesValidacion[campo];
          for (const error in control.errors) {
            if (error in control.errors) {
              this.erroresFormulario[campo] += mensajes[error] + ' ';
            }
          }
        }
      }
    }
    this.formStatus = false;
    if (this.formularioDatos.status === 'VALID') {
      this.formStatus = true;
    }
  }


  ngOnInit() {
    this._controlFormsService.itemValueTime.pipe(takeUntil(this._finisher)).subscribe((nextValue) => {
      if(!nextValue){
        this.formularioDatos.get('Name').disable();
        this.formularioDatos.get('Grade').disable();
        this.formularioDatos.get('Age').disable();
        this.formularioDatos.get('Place').disable();
      }
    });


    let value = this.sfcontrol.value;
    if(value){
      let input = value as string;

      const data: StudentModel[] = input ? input.split('#').map( i => JSON.parse(i) ) : [];
  
      this._students$.next(data);
      this.dataSource.data = data;
    }
    

    this.sfcontrol.valueChanges
    .pipe(
      //take(1)
    ).subscribe( value => {
        let input = value as string;

        const data: StudentModel[] = input ? input.split('#').map( i => JSON.parse(i) ) : [];
    
        this._students$.next(data);
        this.dataSource.data = data;
      }
    );


    if (this.sfcontrol.data[0] instanceof Observable ) {
      this.sfcontrol.data[0]
        .pipe(
          filter( day => !isNullOrUndefined(day) ),
          takeUntil( this._finisher )
        )
        .subscribe( i => {
          } 
        );
    }

    this._students$.subscribe( data => {
        this._students = [...data];

        /* if (data.length === 0) {
          this.formularioDatos.get('day').disable();
        } else {
          this.formularioDatos.get('day').enable();
        } */

      } 
    );

    // AGREGAR
    this._addElement
      .pipe(
        filter( i => !isNullOrUndefined(i) ),
        switchMap( schedule => this._students$
          .pipe(
            map( lists => [...lists, schedule] ),
            take(1)
          ) 
        ),
        takeUntil( this._finisher )
      ).subscribe( i =>  {
          const data = [...i];//this.multipleSort( i );
          this._students$.next( data );
          this.dataSource.data = data;    
          this.updateValue( data );
        }   
      );

    // BORRAR
    this._deleteElement
      .pipe(
        filter( i => !isNullOrUndefined(i) ),
        switchMap( id => this._students$
          .pipe(
            map( list => list.filter( i => i.id !== id) ),
            take(1)
          ) 
        ),
        takeUntil( this._finisher )
      ).subscribe( data => {
        this._students$.next( data );
        this.dataSource.data = data;
        this.updateValue( data );
        } 
      );

  }

  public onSubmit(directivaFormulario: FormGroupDirective): void {
    const data = this.formularioDatos.value;

      const dataCreate: StudentModel = {
        ...data, 
        id: UniqueIdGenerator.generate(),
      }
      
      this._addElement.next( dataCreate );
  
      directivaFormulario.resetForm();
  }

  public delete(data: string): void {
    this._deleteElement.next( data );
  }

  private updateValue( list: StudentModel[] ): void {
    this.sfcontrol.markAsDirty();
    this.sfcontrol.setValue(list.map( i => JSON.stringify(i)).join('#'));
  }


  ngOnDestroy() {
    this._finisher.next();
  }


}


